import { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { contacts } from "../data/contacts";
import { getLang, getStoreId, getStores } from "../redux/selectors";
import { Collapse } from "@mui/material";
import { Notice } from "./Notice";
import { ServingAreaSelector } from "./ServingAreaSelector";

export const Delivery = () => {
  const storeId = useSelector(getStoreId) || "682b89f4c28a3e5c9c0ce408";
  const choosenStoreId = useSelector(getStoreId);
  const stores = useSelector(getStores);
  const lang = useSelector(getLang);
  const currentStore = stores.find((store) => store._id === storeId);
  const phone = currentStore ? currentStore.phone : contacts.phone;
  const phoneCall = currentStore
    ? currentStore.contacts.find((contact) => contact.name === "phone").link
    : "tel:" + contacts.phoneCall;

  const [openDetails, setOpenDetails] = useState(false);
  const moreDetails = lang === "en" ? "Delivery details" : "Про доставку";
  const hideDetails = lang === "en" ? "Hide details" : "Приховати деталі";

  const deliveryDetailsData = currentStore.delivery[lang];

  const chunkedData = [];
  for (let i = 0; i < deliveryDetailsData.length; i += 2) {
    chunkedData.push(deliveryDetailsData.slice(i, i + 2));
  }

  return (
    <>
      {choosenStoreId ? (
        <div>
          <h3 className="section-header delivery-header text-2xl md:text-4xl flex flex-col md:flex-row items-center justify-center text-center md:gap-4">
            <span>Delivery {currentStore.title}</span>
            <a
              href={phoneCall}
              className="phone-link flex items-center text-mainRed"
            >
              <Icon
                icon="mingcute:phone-fill"
                className="phone-icon text-2xl md:text-4xl mx-1 md:mx-2"
              />
              <h3 className="phone text-2xl md:text-4xl">{phone}</h3>
            </a>
          </h3>

          <Collapse in={openDetails}>
            <div className="mb-4 md:w-[80%] md:mx-auto">
              <div className="flex flex-col md:flex-row md:flex-wrap text-base md:text-lg">
                {chunkedData.map((group, idx) => (
                  <div
                    key={idx}
                    className={`flex flex-col ml-4 md:ml-0 ${
                      group.length === 1 ? "ml-4 md:mx-auto" : ""
                    }`}
                  >
                    {group.map((text, index) => (
                      <p
                        key={index}
                        className="relative pl-6 mb-2 md:ml-10 text-left before:absolute before:left-0 before:top-2 before:w-2 before:h-2 before:rounded-full before:bg-mainRed"
                      >
                        {text}
                      </p>
                    ))}
                  </div>
                ))}
              </div>
              <Notice />
            </div>
          </Collapse>

          <div
            onClick={() => setOpenDetails((prev) => !prev)}
            className="-mt-2 text-lg md:text-xl text-mainRed font-bold cursor-pointer flex items-center justify-center gap-2"
          >
            <Icon
              icon={`tabler:chevrons-${!openDetails ? "down" : "up"}`}
              className="text-3xl animate-pulse"
            />
            <span className="text-mainBlack">
              {openDetails ? hideDetails : moreDetails}
            </span>
            <Icon
              icon={`tabler:chevrons-${!openDetails ? "down" : "up"}`}
              className="text-3xl animate-pulse"
            />
          </div>
        </div>
      ) : (
        <ServingAreaSelector />
      )}
    </>
  );
};
